import React from 'react';
import WhyMultiIonSection from '../components/WhyMultiIonSection';

const ComparisonPage = () => {
  return (
    <div className="pt-20">
      <section className="py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Performance <span className="text-emerald-400">Comparison</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            See how Multi-Ion technology compares to traditional lithium-ion batteries.
          </p>
        </div>
      </section>
      <WhyMultiIonSection />
    </div>
  );
};

export default ComparisonPage;
